<template>
  <v-container>
    <v-form v-model="valid" autocomplete="on" @submit.prevent="submit">
      <v-layout column wrap>
        <v-text-field
          v-model="login"
          box
          height="50px"
          background-color="#fff"
          type="text"
          name="login"
          label="Логин"
          light
          :rules="loginRules"
          required
          autocomplete="on"
        ></v-text-field>
        <v-text-field
          v-model="password"
          box
          height="50px"
          light
          :rules="passwordRules"
          background-color="#fff"
          type="password"
          name="password"
          label="Пароль"
          required
          autocomplete="on"
        ></v-text-field>
        <v-btn type="submit" dark>Войти</v-btn>
        <span
          v-if="error.message"
          class="error">
          {{ error.message }}
        </span>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    valid: false,
    login: '',
    loginRules: [
      v => !!v || 'Логин обязателен',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Пароль обязателен',
    ],
  }),
  computed: {
    ...mapState('user', ['error']),
  },
  methods: {
    ...mapMutations(['SET_API_KEY','GET_APP_TOKEN']),
    ...mapActions('user', ['authorize']),

    submit() {
      this.authorize({
        login: this.login,
        password: this.password,
      })
        .then((data) => {
          this.SET_API_KEY(data.apiKey);
          if (data && data.user){
            this.$storage.set('flowType', data.user.flowType);
            this.$router.push({ name: 'buy-phones' })
          };
        });
    },
  },
  created(){
    if(this.$storage.get('login')){
      var login = this.$storage.get('login');
      var pass = this.$storage.get('password');
      
      this.authorize(
        {
          login: login,
          password: pass
        }
      ).then((data) => {
        this.$storage.remove('login')
        this.$storage.remove('password')
        this.SET_API_KEY(data.apiKey);
        if (data && data.user){
            this.$storage.set('flowType', data.user.flowType);
            this.$router.push({ name: 'buy-phones' })
        };
      });
      
    }else if (this.$storage.get('user-info')){
      this.$router.push({ name: 'buy-phones' });
    }
  },

};
</script>
